import { Models } from '../../pipeline/models/global.models';

export interface Opportunity {
  dropdownLabel?: string | OpportunityDropdownLabel;
  tagName?: string;
  tagGuid?: string;
  viewName?: string;
  cashOutTypes?: Models.CashOutType[];
  heatmapColumn?: string;
}

export interface HelocTab {
  tabName?: string;
  selected?: boolean;
  type?: Models.HelocType;
  amount?: number;
}

export const possibleOpportunities: Opportunity[] = [
  {
    dropdownLabel: 'Debt Consolidation',
    tagName: 'Debt Consol.',
    viewName: 'Debt Consolidation',
    cashOutTypes: [Models.CashOutType.Debt],
    heatmapColumn: Models.HeatMapColumnNamesEnum.RevolvingDebt,
  },
  {
    dropdownLabel: 'Cash-Out',
    tagName: 'Cash-Out',
    viewName: 'Cash-Out Refinance',
    cashOutTypes: [Models.CashOutType.Max, Models.CashOutType.Mid],
    heatmapColumn: Models.HeatMapColumnNamesEnum.EstCashout,
  },
  {
    dropdownLabel: 'Rate Refinance',
    tagName: 'Rate',
    viewName: 'Rate Refi',
    cashOutTypes: [Models.CashOutType.None],
  },
  {
    dropdownLabel: 'MI Removal',
    tagName: 'MI Removal',
    viewName: 'MI Removal',
    cashOutTypes: [Models.CashOutType.None],
  },
  {
    dropdownLabel: 'HELOC',
    tagName: 'HELOC',
    viewName: 'HELOC',
    cashOutTypes: [Models.CashOutType.Max, Models.CashOutType.Mid],
  },
];

export enum OpportunityTagName {
  DebtConsol = 'Debt Consol.',
  CashOut = 'Cash-Out',
  Rate = 'Rate',
  MIRemoval = 'MI Removal',
  HELOC = 'HELOC',
}

export enum OpportunityDropdownLabel {
  DebtConsolidation = 'Debt Consolidation',
  CashOut = 'Cash-Out',
  RateRefinance = 'Rate Refinance',
  MIRemoval = 'MI Removal',
  HELOC = 'HELOC',
}

export interface HelocOfferDetails {
  key?: string;
  amount?: number;
}

export const quickRateScenarioTypes = ['Debt Consol.', 'Cash-Out', 'Rate', 'MI Removal'];
